<template>
	<div class="CategoriesDD">
		<div class="mdms">
			<nav class="main_nav">
				<p class="input-label">Category</p>
				<ul style="margin-top:4px">
					<li class="first__li">
						<!-- <div class="mdms__input">
                            <input type="text" placeholder="select category" />
            </div>-->
						<div class="display__selected">
							<simplebar class="display__selected--scroll">
								<span v-if="!cat_selected.length" class="placeholder ">Select Category</span>
								<span
									v-for="(item, index) in cat_selected"
									:key="index"
									class="mdms__selected"
									@click="removeFromCatArray(item)"
								>
									<span class="mdms__selected--val text-xxs">{{ item.name }}</span>
									<i class="el-icon-close pl-1 text-xxs" />
								</span>
							</simplebar>
						</div>

						<ul>
							<li v-for="(level1, index1) in categories" :key="index1">
								<div
									class="displayVal"
									@click="pushToCategoryArray($event, level1)"
								>
									<span>{{ level1.name }}</span>
									<i v-if="level1.isSelected" class="el-icon-check text-xs" />
								</div>
								
								<ul v-if="!level1.isSelected && level1.hasOwnProperty('categories')">
									<li v-for="(level2, index2) in level1.categories.length > 0 ? level1.categories : level1.products" :key="index2"
									>
										<div
											class="displayVal"
											@click="pushToCategoryArray($event, level2)"
										>
											<span>{{ level2.name }}</span>
											<i v-if="level2.isSelected" class="el-icon-check text-xs" />
										</div>

										<ul v-if="!level2.isSelected && level2.hasOwnProperty('subcategories')">
											<li v-for="(level3, index3) in level2.subcategories.length > 0 ? level2.subcategories : level2.products" :key="index3">
												<div
													class="displayVal"
													@click="pushToCategoryArray($event, level3)"
												>
													<span>{{ level3.name }}</span>
													<i
														v-if="level3.isSelected"
														class="el-icon-check text-xs"
													/>
												</div>

												<!-- <ul v-if="!level3.isSelected && level3.hasOwnProperty('products')">
													<li v-for="(level4, index4) in level3.products" :key="index4">
														<div class="displayVal" @click="pushToCategoryArray($event, level4)">
															<span>{{ level4.name }}</span>
															<i v-if="level4.isSelected" class="el-icon-check text-xs"/>
														</div>
													</li>
												</ul> -->
											</li>
										</ul>
									</li>
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "../../eventBus";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

export default {
	components: {
		simplebar
	},
	data() {
		return {
			cat_selected: [],
			cat_basics: ""
		};
	},
	computed: {
		...mapState("CommonStore", ["categories"])
	},
	created() {
		this.getCategories();
	},
	methods: {
		...mapActions("CommonStore", ["getCategories"]),

		pushToCategoryArray(event, selectedObj) {
			EventBus.$emit("breadCrumbs", []);
			// display array is loc_selected array.
			// push the selected obj to the display array to display the selected field,
			// and also remove the selected field from the display area.
			// and also remove the fields if cat_basics field changes

			this.cat_basics = selectedObj.type; // set the cat_basics so that other selected fields can be removed from display array

			selectedObj.isSelected = !selectedObj.isSelected; // toggle selected field
			
			if (selectedObj.isSelected) {
				this.cat_selected.push(selectedObj); // push selected field to display array.
			} else {
				this.removeCatElement(selectedObj); // remove field from the display array
			}

			const duplicateloc_selected = this.cat_selected.slice(); // duplicate the display array
			
			duplicateloc_selected.map(obj => {
				// remove fields if cat_basics field is changed
				if (obj.type != this.cat_basics) {
					this.removeFromCatArray(obj);
				}
			});
			
			this.$emit("categoryUpdate", {
				cat_basics: this.cat_basics,
				cat_selected: this.cat_selected
			});
		},

		removeFromCatArray(removedObj) {
			EventBus.$emit("breadCrumbs", []);
			// reomove the selected field from dipslay array.
			removedObj.isSelected = false; // make the selected field to false
			this.removeCatElement(removedObj); // actual removal of field
		},

		removeCatElement(elementToRemove) {
			// check each element in the array and remove the field.
			this.cat_selected.forEach((obj, i, arr) => {
				if (obj.id === elementToRemove.id) {
					arr.splice(arr.indexOf(obj), 1);
				} // remove the selected value from the screen
			});
			this.$emit("categoryUpdate", {
				cat_basics: this.cat_basics,
				cat_selected: this.cat_selected
			});
		}
	}
};
</script>

<style scoped lang="scss">
@import "./BaseCategoriesDD.scss";
</style>
